<template>
  <div class="flex flex-column flex-1">
    <u-header show-back>修改密码</u-header>
    <div class="scrollable container flex-1 flex flex-row">
      <form name="form" class="flex-1" @submit.prevent="reset">
        <u-input type="password" class="form-control" placeholder="请输入原密码" v-model="old" autofocus tabindex="1">
          <span v-if="submitted&&validation.hasError('old')" slot="right" class="input-error">{{validation.firstError('old')}}</span>
        </u-input>
        <u-input type="password" class="form-control" placeholder="请输入新密码" v-model="password" tabindex="2">
          <span v-if="submitted&&validation.hasError('password')" slot="right" class="input-error">{{validation.firstError('password')}}</span>
        </u-input>
        <u-input type="password" class="form-control" placeholder="请再次输入新密码" v-model="repeat" tabindex="3">
          <span v-if="validation.hasError('repeat')" slot="right" class="input-error">{{validation.firstError('repeat')}}</span>
        </u-input>
        <u-button native-type="submit" style="margin-top: 40px">重置密码</u-button>
      </form>
    </div>
  </div>
</template>
<script>
import { Validator } from 'simple-vue-validator'
import AV from 'leancloud-storage'
export default {
  data () {
    return {
      old: '',
      password: '',
      repeat: '',
      submitted: false
    }
  },
  validators: {
    old: {
      debounce: 300,
      validator (v) {
        return Validator.value(v).required('原密码必填')
      }
    },
    password: {
      debounce: 300,
      validator (v) {
        return Validator.value(v).required('密码必填').minLength(6, '至少6位以上的密码')
      }
    },
    'repeat, password': {
      debounce: 300,
      validator (repeat, password) {
        if (this.submitted || this.validation.isTouched('repeat')) {
          return Validator.value(repeat).required('请再次输入新密码').match(password, '两次密码不一致')
        }
      }
    }
  },
  methods: {
    reset () {
      this.submitted = true
      this.$validate().then(isSuccess => {
        if (isSuccess) {
          AV.User.current().updatePassword(this.old, this.password).then(() => {
            this.$toast('密码已重置，请使用新密码登录')
            return AV.User.logOut().then(() => {
              this.$router.push('/auth')
            })
          }).catch(error => {
            if (error.code === 210) {
              this.$toast('原密码不匹配')
            } else {
              this.$toast(JSON.stringify(e))
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// ResetPassword.vue?4fc24ce6